import React, { useState } from 'react';
import { Menu, X, ShieldCheck } from 'lucide-react';
import MenuAdmin, {AdminSection} from '../components/dashboardAdmin/MenuAdmin';
import UsersView from '../components/dashboardAdmin/UsersView';
import AdminReportsView from '../components/dashboardAdmin/AdminReportsView';
import AdminInvoicesView from '../components/dashboardAdmin/AdminInvoicesView';
import InvitationsView from '../components/dashboardAdmin/InvitationsView';

const DashboardAdmin: React.FC = () => {
    const [activeSection, setActiveSection] = useState<AdminSection>('users');
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const renderContent = () => {
        switch (activeSection) {
            case 'users':
                return <UsersView />;
            case 'reports':
                return <AdminReportsView />;
            case 'invoices':
                return <AdminInvoicesView />;
            case 'invitations':
                return <InvitationsView />;
            case 'statistics':
                return (
                    <div className="flex flex-col items-center justify-center h-64 text-gray-400">
                        <ShieldCheck size={48} className="mb-4 text-gray-300" />
                        <p className="text-lg font-medium">Estadísticas — Próximamente</p>
                        <p className="text-sm mt-1">Esta sección está en desarrollo.</p>
                    </div>
                );
            default:
                return <UsersView />;
        }
    };

  return (
    <div className="flex flex-col overflow-hidden">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#144A7B] to-[#2F75B5] text-white py-6 px-4 shadow-lg flex-shrink-0">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div>
            <div className="flex items-center gap-3">
              <h1 className="text-2xl md:text-3xl font-bold">Panel de Administración</h1>
              <span className="hidden sm:inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold bg-white/20 text-white border border-white/30">
                <ShieldCheck size={12} />
                ADMIN
              </span>
            </div>
            <p className="text-blue-100 mt-1">Gestiona usuarios, documentos y configuración del sistema</p>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 rounded-lg hover:bg-blue-700 transition"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      <div className="max-w-7xl w-full mx-auto py-6 flex-1 flex flex-col overflow-hidden">
        <div className='flex flex-col lg:flex-row gap-6 flex-1 overflow-hidden'>
            {/* Sidebar Menu - Desktop */}
            <MenuAdmin
                activeSection={activeSection}
                setActiveSection={setActiveSection}
                isMobileMenuOpen={isMobileMenuOpen}
                setIsMobileMenuOpen={setIsMobileMenuOpen}
            />
            {/* Main Content Area */}
            <main className="flex-1 bg-white rounded-lg shadow-lg p-6 overflow-y-auto">
                {renderContent()}
            </main>
        </div>
      </div>

    </div>
  );
};

export default DashboardAdmin;
